import Icon from 'helpers/svg-icon';

const OptInIcon = ({ width = 182, height = 131, className }) => (
  <Icon
    viewBox="0 0 182.44 131.12"
    width={width}
    height={height}
    className={className}>
    <defs>
      <clipPath id="a">
        <path
          d="M30.37 29.39H56.1v69.6H30.37z"
          style={{
            fill: 'none',
            strokeWidth: 0,
          }}
        />
      </clipPath>
      <clipPath id="b">
        <path
          d="M56.1 29.39h25.73v69.6H56.1z"
          style={{
            fill: 'none',
            strokeWidth: 0,
          }}
        />
      </clipPath>
    </defs>
    <g data-name="Layer 1">
      <path
        d="M2 2.62h152.5v107.5H2z"
        style={{
          fill: '#f7f7f7',
          strokeWidth: 0,
        }}
      />
      <path
        d="M2 2h152.5v17.5H2z"
        style={{
          fill: '#fff',
          strokeWidth: 0,
        }}
      />
      <path
        d="M0 0v112.12h156.5V0H0Zm152.5 4.62V17.5H4V4.62h148.5Zm0 103.5H4V21.5h148.5v86.62Z"
        style={{
          fill: '#e5e5e5',
          strokeWidth: 0,
        }}
      />
      <path
        d="M8.5 8.92h4v4h-4zM16.5 8.92h4v4h-4z"
        style={{
          fill: '#e5e5e5',
          strokeWidth: 0,
        }}
      />
      <path
        d="M110.34 32.12h56v97h-56z"
        style={{
          fill: '#fff',
          strokeWidth: 0,
        }}
      />
      <path
        d="M110.34 46.12h56v69h-56z"
        style={{
          fill: '#f7f7f7',
          strokeWidth: 0,
        }}
      />
      <path
        d="M108.34 30.12v101h60v-101h-60Zm4 18h52v65h-52v-65Zm52 79h-52v-10h52v10Zm-52-83v-10h52v10h-52Z"
        style={{
          fill: '#e5e5e5',
          strokeWidth: 0,
        }}
      />
      <path
        d="M180.44 92.41h-40.21l-9.79 8.71v-8.71h-8.06V55.92h58.06v36.49z"
        style={{
          fill: '#fff',
          strokeWidth: 0,
        }}
      />
      <path
        d="M128.45 105.58V94.4h-8.07V53.91h62.06V94.4h-41.46l-12.54 11.18Zm-4.07-15.17h8.06v6.26l7.03-6.26h38.98V57.92h-54.06v32.49Z"
        style={{
          fill: '#e5e5e5',
          strokeWidth: 0,
        }}
      />
      <path
        d="m133.78 74.5-3.52-.86.59-1.84 3.37 1.49-.32-3.87h1.97l-.35 3.93 3.34-1.46.59 1.88-3.58.82 2.41 2.9-1.6 1.16-1.9-3.34-1.9 3.24-1.61-1.11 2.5-2.94ZM144.82 74.5l-3.52-.86.59-1.84 3.37 1.49-.32-3.87h1.97l-.35 3.93 3.34-1.46.59 1.88-3.58.82 2.41 2.9-1.6 1.16-1.9-3.34-1.9 3.24-1.61-1.11 2.5-2.94ZM155.85 74.5l-3.52-.86.59-1.84 3.37 1.49-.32-3.87h1.97l-.35 3.93 3.34-1.46.59 1.88-3.58.82 2.41 2.9-1.6 1.16-1.9-3.34-1.9 3.24-1.61-1.11 2.5-2.94ZM166.89 74.5l-3.52-.86.59-1.84 3.37 1.49-.32-3.87h1.97l-.35 3.93 3.34-1.46.59 1.88-3.58.82 2.41 2.9-1.6 1.16-1.9-3.34-1.9 3.24-1.61-1.11 2.5-2.94ZM134.34 37.08h8v4h-8z"
        style={{
          fill: '#e5e5e5',
          strokeWidth: 0,
        }}
      />
      <g
        style={{
          clipPath: 'url(#a)',
        }}>
        <path
          d="M64.37 97.29c-17.84 0-32.3-14.46-32.3-32.3V43.74l32.3-11.9V97.3Z"
          style={{
            fill: '#fff',
            strokeWidth: 0,
          }}
        />
        <path
          d="M66.37 99.29h-2c-18.92 0-34.3-15.39-34.3-34.3V42.34l36.3-13.38v70.33Zm-32.3-54.16v19.86c0 16.04 12.52 29.21 28.3 30.24V34.71l-28.3 10.43Z"
          style={{
            fill: '#e5e5e5',
            strokeWidth: 0,
          }}
        />
      </g>
      <g
        style={{
          clipPath: 'url(#b)',
        }}>
        <path
          d="M47.83 97.29c17.84 0 32.3-14.46 32.3-32.3V43.74l-32.3-11.9V97.3Z"
          style={{
            fill: '#fff',
            strokeWidth: 0,
          }}
        />
        <path
          d="M47.83 99.29h-2V28.96l36.3 13.38v22.65c0 18.92-15.39 34.3-34.3 34.3Zm2-64.59v60.52c15.78-1.03 28.3-14.2 28.3-30.24V45.12l-28.3-10.43Z"
          style={{
            fill: '#e5e5e5',
            strokeWidth: 0,
          }}
        />
      </g>
      <path
        d="m51.7 73.79-7.69-8.11 2.91-2.75 4.92 5.2 14.12-13.45 2.76 2.89L51.7 73.79z"
        style={{
          fill: '#e5e5e5',
          strokeWidth: 0,
        }}
      />
    </g>
  </Icon>
);
export default OptInIcon;
